import { ButtonHTMLAttributes, ReactNode } from "react";
import clsx from "clsx";
import { Loader2 } from "lucide-react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string | ReactNode;
  icon?: ReactNode;
  iconPosition?: "left" | "right";
  outline?: boolean;
  loading?: boolean;
  backgroundColor?: string;
  textColor?: string;
  borderColor?: string;
  hoverColor?: string;
  ringColor?: string;
  onClick?: () => void;
}

export default function Button({
  label,
  icon,
  iconPosition = "left",
  className,
  outline = false,
  loading = false,
  backgroundColor = "bg-primary-600",
  textColor = "text-white",
  borderColor = "border-gray-500",
  hoverColor = "hover:bg-primary-700",
  ringColor = "focus:ring-primary-400",
  disabled,
  ...rest
}: ButtonProps) {
  return (
    <button
      disabled={loading || disabled}
      aria-busy={loading}
      className={clsx(
        "flex items-center cursor-pointer justify-center gap-2 px-4 py-2 rounded-full transition font-medium focus:ring-2",
        outline
          ? `${borderColor} text-gray-700 bg-transparent hover:bg-gray-100 ${ringColor}`
          : `${backgroundColor} ${textColor} ${hoverColor} ${ringColor}`,
        (loading || disabled) && "opacity-50 cursor-not-allowed",
        className
      )}
      {...rest} // Passa todas as props extras (ex: onClick, type, id, etc.)
    >
      {loading ? (
        <Loader2 className="animate-spin" size={20} />
      ) : (
        <>
          {icon && iconPosition === "left" && icon}
          {typeof label === "string" ? <span>{label}</span> : label}
          {icon && iconPosition === "right" && icon}
        </>
      )}
    </button>
  );
}
